<span class="text-nowrap" i18n>Active Client: </span>
@if(clients().length > 1){
  <mat-select
  [value]="currentClient"
  (selectionChange)="updateClient($event.value)"
  aria-label="Select active client"
>
  @for (client of clients(); track client) {
  <mat-option [value]="client">{{ client }}</mat-option>
  }
</mat-select>
}@else {
  <span class="active-client">{{ currentClient }}</span>
}
